// uses the bootstrap modal. just swapping content out.
import { getVideoPosterUrl, getIdFromAssetUrl, getFileNameFromVideoEmbedUrl } from './widen-utils';

const videoModal = () => {
  const videosWrapper = document.querySelector('.documents-dropdown');
  const modal = document.querySelector('.modal');
  const modalTitle = modal.querySelector('.modal-title');
  const modalBody = modal.querySelector('.modal-body');

  videosWrapper.addEventListener('click', (e) => {
    if (e.target.classList.contains('video-link')) {
      modal.classList.toggle('show');
      const videoSrc = e.target.dataset.videoLink;
      const posterUrl = getVideoPosterUrl(getFileNameFromVideoEmbedUrl(videoSrc), getIdFromAssetUrl(videoSrc));
      modalBody.innerHTML = `<video class="ratio ratio-16x9" controls poster="${posterUrl}">
        <source src='${videoSrc}' type="video/mp4">
      </video>`;
      modalTitle.innerHTML = e.target.innerText;
    }
  });

  modal.addEventListener('hide.bs.modal', () => {
    const video = modal.querySelector('video');
    modal.classList.toggle('show');
    video.pause();
    video.currentTime = 0;
  });
};

export default videoModal;
